<svg class="icon" *ngIf="path">
    <use [attr.xlink:href]="path + '#icon'"></use>
</svg>
<i class="bi bi-{{ name }}" *ngIf="name"></i>
